member = window.member || {};
member.person = {};
member.person.nextMemberId = null;
member.person.status = {};
member.person.status.enabled = null;
member.person.edit = {};
member.person.edit.init = function () {
	var $memberId = $('#memberId');
	if (!$memberId.val()) {
		var $status = $('#status');
		var $memberIdDesc = $('#elm_memberId').find('.description');
		$memberIdDesc.hide();
		$memberId.prop('disabled', true).css('background-color', '#eee');
		$status.change(function () {
			if (parseInt($(this).val()) === member.person.status.enabled) {
				$('#memberId').val(member.person.nextMemberId);
				$memberId.prop('disabled', false).css('background-color', '#fff');
				$memberIdDesc.show();
			}
			else  {
				$('#memberId').val('');
				$memberId.prop('disabled', true).css('background-color', '#eee');
				$memberIdDesc.hide();
			}
		});
	}

	/*
	var qrcode = new QRCode(document.getElementById("qrcode"), {
		text: "http://jindo.dev.naver.com/collie",
		width: 128,
		height: 128,
		colorDark : "#000000",
		colorLight : "#ffffff",
		correctLevel : QRCode.CorrectLevel.H
	});
	*/
};
member.person.initSearch = function() {
	// quick search regex
	var qsRegex;

	// init Isotope
	var $grid = $('.members.list').isotope({
		itemSelector: '.member',
		layoutMode: 'fitRows',
		filter: function() {
			return qsRegex ? $(this).text().match( qsRegex ) : true;
		}
	});

	// use value of search field to filter
	var $quicksearch = $('.quicksearch').keyup( debounce( function() {
		qsRegex = new RegExp( $quicksearch.val(), 'gi' );
		$grid.isotope();
	}, 200 ) );

	// debounce so filtering doesn't happen every millisecond
	function debounce( fn, threshold ) {
		var timeout;
		return function debounced() {
			if ( timeout ) {
				clearTimeout( timeout );
			}
			function delayed() {
				fn();
				timeout = null;
			}
			timeout = setTimeout( delayed, threshold || 100 );
		}
	}
};
member.person.details = {}
member.person.details.init = function () {
	var $form = $('#member form.details');
	var $occupation = $form.find('#occupation');
	var $workplace = $form.find('#workplace');

	$occupation.change(function () {
		$workplace.prop('disabled', false);
		if ($(this).val().indexOf('FREELANCE') >= 0) {
			$workplace.val('-1');
			$workplace.prop('disabled', true);
		}
	}).trigger('change');
};
member.person.credentials = {}
member.person.credentials.init = function () {
	var $form  = $('#member form.credentials');
	$form.find('.checkbox').change(function () {
		var $this = $(this);
		var $fieldset = $this.parent().parent().next();
		var $mailAddress = $('body').find('#elm_mailAddress');

		if ($this.hasClass('mail')) {
			$fieldset.parent()
				.find('.mail')
				.not('#' + $this.attr('id'))
				.prop('checked', false);
		}

		$mailAddress.toggle(false);
		if ($this.attr('id') === 'typeMail') {
			$mailAddress.toggle($this.is(":checked"));
		}

	}).trigger('change');
}